<template>
  <div class="mb-4">
    <div
      class="max-h-full h-auto px-4 overflow-hidden"
      :class="[$style['card-transition'], $style['layout-color'], { 'py-2': !isFeedbackFinish, 'py-2': isFeedbackFinish }]">
      <div class="flex flex-wrap items-center justify-center">
        <transition name="slide-up-small">
          <div
            v-show="!isFeedbackFinish"
            class="font-semibold text-lg text-center">
            {{ eventFeedback.rateTitle }}
          </div>
        </transition>

        <div
          class="relative z-10 w-full text-center"
          :class="{ 'mb-4': !isFeedbackFinish }"
          :style="[$style['layout-color'], { height: isFeedbackFinish ? '2.25rem' : '3.25rem' }]">
          <XStarRating
            ref="stars"
            :stars="5"
            :starActiveClass="$style['star-active']"
            :starClass="$style['star']"
            class="absolute pin-l w-full"
            :class="[$style['font-size-transition'], { 'text-2xl': isFeedbackFinish, 'text-4xl': !isFeedbackFinish }]"
            v-model="reactionEventFeedback.rating"
            @change="onSubmit" />
        </div>
      </div>

      <transition name="slide-up-large">
        <div
          v-if="showCommentSection && !isFeedbackFinish"
          class="relative text-center mx-auto mt-3"
          :class="$style['comment']">
          <XTextarea
            :label="eventFeedback.commentTitle"
            :labelClass="['font-semibold', 'text-grey-50', 'text-sm', 'text-center', 'mb-4']"
            class="mx-auto"
            v-model="reactionEventFeedback.comment"
            rows="5"
            maxlength="1000" />

          <div class="flex flex-wrap justify-between w-full">
            <div
              class="cursor-pointer text-sm py-1 font-medium text-grey-60 hover:text-grey-30 transition transition-text"
              @click="onSubmitRemoveFeedback">
              {{ $t('event.timeline.eventFeedback.buttonActions.remove') }}
            </div>

            <XButton
              class="font-semibold"
              color="primary"
              size="medium"
              @click="onSubmit">
              {{ $t('event.timeline.eventFeedback.buttonActions.send') }}
            </XButton>
          </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapState } from 'vuex'

import XStarRating from '@plat/components/StarRating'

export default {
  components: {
    XStarRating
  },

  props: {
    value: {
      type: Object,
      default: null
    },
    eventFeedback: {
      type: Object
    }
  },

  data () {
    const reactionEventFeedback = this.value ? this.value.data : {}

    return {
      reactionEventFeedback: {
        rating: 0,
        comment: '',
        ...reactionEventFeedback
      },
      showCommentSection: !!reactionEventFeedback.rating,
      isFeedbackFinish: !!reactionEventFeedback.rating
    }
  },

  computed: {
    ...mapState({
      attendeeId: state => state.routeParameters.attendee.id
    })
  },

  methods: {
    onSubmit (event) {
      this.showCommentSection = !!event.value
      this.isFeedbackFinish = !event.value

      this.saveEventFeedback()
    },

    onSubmitRemoveFeedback () {
      this.removeEventFeedback()
        .then(result => {
          if (result.data.attendee.removeEventFeedback) {
            this.isFeedbackFinish = false
            this.reactionEventFeedback.rating = 0
            this.reactionEventFeedback.comment = ''
          }

          this.showCommentSection = false
        })
    },

    saveEventFeedback () {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation saveEventFeedback($attendeeId: Uuid!, $rating: Int!, $comment: String) {
              attendee(attendeeId: $attendeeId) {
                saveEventFeedback(rating: $rating, comment: $comment) {
                  id
                }
              }
            }
          `,
          variables: {
            attendeeId: this.attendeeId,
            rating: this.reactionEventFeedback.rating,
            comment: this.reactionEventFeedback.comment
          }
        })
    },

    removeEventFeedback () {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation removeEventFeedback($attendeeId: Uuid!) {
              attendee(attendeeId: $attendeeId) {
                removeEventFeedback
              }
            }
          `,
          variables: {
            attendeeId: this.attendeeId
          }
        })
    }
  }
}
</script>

<style module>
.star-active {
  color: #fdd817;
}

.star {
  color: #c7c7c7;
}

.comment {
  max-width: 375px;
}

.font-size-transition {
  transition: font-size .2s ease;
  will-change: font-size;
}

.card-transition {
  will-change: max-height, height;
}

.layout-color {
  background-color: #fafafa;
}
</style>
